import React from "react"

type Props = {}

export default function Notfound({}: Props) {
  return <div>Notfound</div>
}
